module.exports = __webpack_public_path__ + "img/app-pay.0db6f9d9.png";